function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseThin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m62.932 57.777-25.777-25.777 25.777-25.777a3.6454 3.6454 0 0 0 0-5.1554 3.6454 3.6454 0 0 0-5.1554 0l-25.777 25.777-25.777-25.777a3.6454 3.6454 0 0 0-5.1554 0 3.6454 3.6454 0 0 0 0 5.1554l25.777 25.777-25.777 25.777a3.6454 3.6454 0 0 0 0 5.1554 3.6454 3.6454 0 0 0 5.1554 0l25.777-25.777 25.777 25.777a3.6454 3.6454 0 0 0 5.1554 0 3.6454 3.6454 0 0 0 0-5.1554z",
    fill: "currentColor",
    style: {
      strokeWidth: 3.6454
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseThin);
export default __webpack_public_path__ + "static/media/close-thin.788a88d8.svg";
export { ForwardRef as ReactComponent };